import React from 'react'
import PropTypes from 'prop-types'
import errorDisplayHandler from './errorDisplayHandler'
import styles from './ErrorPage.module.scss'
import {
  HeaderLogo,
} from 'belle-js'
import PrivateWealthEmailLink from '../Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

const ErrorPage = (props) => {
  const {
    error,
    isMobile,
    appType,
    location: { prev: { pathname } }
  } = props

  const errorObject = errorDisplayHandler.getError(error, appType)

  const { heading, copy, cta } = errorObject

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <HeaderLogo size={isMobile ? 50 : 60} />
        <p className={styles.logoText}>Ellevest</p>
      </div>
      <div className={styles.content}>
        <div className="intro">
          <h1 className={styles.heading} data-test-id="heading">{heading}</h1>
          <p data-test-id="copy">{copy}</p>
        </div>
        <div className={styles.actions}>
          {cta(pathname)}
          <PrivateWealthEmailLink
            className={styles.helpLink} />
        </div>
      </div>
    </div>
  )
}

ErrorPage.propTypes = {
  error: PropTypes.string,
  isMobile: PropTypes.bool,
  appType: PropTypes.string,
  location: PropTypes.object
}

ErrorPage.defaultProps = {
  error: '',
  isMobile: false,
  appType: 'none',
  location: { prev: {} }
}

export default ErrorPage



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.jsx